export default "__VITE_ASSET__833cd5af__"